<template>
    <div class="container-fluid">
        <form class="form-horizontal"
              @submit.prevent="getConsumptionList">
            <div class="form-group">
                <label class="col-item  control-label">
                    <strong>消费时间:</strong>
                </label>
                <div class="col-item">
                    <span class="time-filter"
                          :class="{'active' : selectedIndex === 0 }"
                          v-on:click="before(0,0)">今天</span>
                    <span class="time-filter"
                          :class="{'active' : selectedIndex === 1}"
                          v-on:click="before(1,3)">近三天</span>
                    <span class="time-filter"
                          :class="{'active' : selectedIndex === 2}"
                          v-on:click="before(2,7)">近七天</span>
                    <span class="time-filter"
                          :class="{'active' : selectedIndex === 3}"
                          v-on:click="before(3,30)">近30天</span>
                </div>
                <div class="col-item">
                    <v-datepicker v-on:input="clearSelectedIndex"
                                  style="width: 200px; display: inline-block"
                                  v-model="useTimeStart" :message="useTimeStart"></v-datepicker>到
                    <v-datepicker v-on:input="clearSelectedIndex"
                                  style="width: 200px; display: inline-block"
                                  v-model="useTimeEnd" :message="useTimeEnd"></v-datepicker>
                </div>

            </div>
            <div class="form-group">
                <label class="col-item control-label">
                    <strong>消费项目:</strong>
                </label>
                <select v-model="dealId" name="dealId" required style="width:400px;display:inline-block;margin-left:20px;">
                    <option v-for="deal in dealList"
                              :value="deal.mtDealId" :key="deal.mtDealId">
                              {{deal.partnerDealName}}
                              </option>
                </select>
                <button class="btn btn-warning"
                        type="submit" v-bind:disabled="!dealId">查询</button>
            </div>
        </form>
        <div class="common-tip-blk">
            <i class="F-glob F-glob-status-info"></i>
            <strong>合计</strong>
            <span>{{useTimeStart}}</span>至
            <span>{{useTimeEnd}}</span>已验证了
            <span>{{totalVerifyNum||0}}</span>张,已撤销
            <span>{{totalRevocationNum||0}}</span>张
        </div>
        <div class="table-wrapper"
             v-loading="isTableLoading"
             element-loading-text="拼命加载中">
            <span class="pull-right">
                <a :href="apiHost+generateUrl"
                   target="_blank">下载明细记录</a>
                <!--外部标签写成div为什么就不能下载-->
            </span>
            <table class="table table-hover table-bordered">
                <thead>
                    <tr>
                        <th class="width-50">验证日期</th>
                        <th>验证数量</th>
                        <th>撤销数量</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in consumptionList">
                        <td>{{item.date| formdate}},{{item.weekday}}</td>
                        <td>{{item.verifyNum}}</td>
                        <td>{{item.revocationNum}}</td>
                        <td>
                            <div>
                                <router-link v-if="item.verifyNum || item.revocationNum"
                                             :to="{ name: 'ticketdetailProgram', params: { 
                                         useTimeStart:getFormateDate(item.date), dealId: item.dealId, dealName: item.dealName}}">查看明细</router-link>
                            </div>
                            <div>
                                <a v-if="!item.verifyNum && !item.revocationNum"
                                   disabled>查看明细</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="nodata"
               v-if="noData">未查询到匹配内容</p>
            <v-pagination class="pull-right"
                          :current='current'
                          :total='totalPage'
                          :size="'md'"
                          :first="false"
                          :last="false"
                          v-on:current-change="currentChangeFunc($event)">
            </v-pagination>
        </div>
    </div>
</template>
<script>
    import api from 'api/verifyHistory'
    import { formatDate as formdate} from 'helpers'
    import { apiHost } from 'config/env.conf.js'
    export default {
        data () {
            return {
                consumptionList: [],
                current: 1,
                perPageCount: 10,
                totalCount: 0,
                isTableLoading: false,
                useTimeEnd: '',
                useTimeStart: '',
                dealId: '',
                bizAccountAccess: 'web',
                noData: false,
                totalVerifyNum: 0,
                totalRevocationNum: 0,
                selectedIndex: 0,
                dealList: [],
                baseUrl: "/meilv/scs/account/v1/voucher/statistics/excel",
                detailUrl: "/mtp/coupon/history/detail/",
                detailInterChar: "#?day=",
                searchInfo: false,
                apiHost: apiHost,
                formdate: formdate
            };
        },
        filters: {
            formdate (time) {
                var date = new Date(time);
                return formdate(date, 'yyyy-MM-dd')
            }
        },
        created: function () {
            api.getDeals({
                bizAccountAccess: this.bizAccountAccess
            }).then((response) => {
                this.isTableLoading = false;
                if (response.status === 0) {
                    if (response.data && response.data && response.data.length) {
                        this.dealList = response.data;
                        this.dealId = response.data[0].mtDealId;
                        //console.log(response.data[0].mtDealId);
                        this.searchInfo = true;
                        this.before(0, 0);
                        this.getConsumptionList();
                    }
                } else {
                    this.alert(response.message || '接口返回信息有误');
                }
            }).catch((error) => {
                this.isTableLoading = false;
                this.dealList = [];
                this.alert(error);
            });
        },
        computed: {
            totalPage () {
                return Math.ceil(this.totalCount / this.perPageCount);
            },
            generateUrl () {
                return this.baseUrl + "?dealId=" + this.dealId + "&useTimeStart=" + this.useTimeStart + "&useTimeEnd=" + this.useTimeEnd;
            },
        },
        methods: {
            alert (message) {
                this.$alert({
                    title: '提示',
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false
                });
            },
            clearSelectedIndex () {
                this.selectedIndex = '';
            },
            getFormateDate (date) {
                return this.formdate(date, 'yyyy-MM-dd');
            },
            getConsumptionList () {
                if (!this.check()){
                    return;
                }
                if (this.searchInfo) {
                    this.dealId = this.dealId;
                    this.useTimeEnd = this.useTimeEnd;
                    this.useTimeStart = this.useTimeStart;
                    this.pageSize = this.pageSize;
                    this.pageNo = this.current;
                }
                this.isTableLoading = true;
                api.getConsumptionList({
                    bizAccountAccess: this.bizAccountAccess,
                    useTimeEnd: this.useTimeEnd,
                    useTimeStart: this.useTimeStart,
                    pageNo: this.current,
                    pageSize: this.perPageCount,
                    dealId: this.dealId
                }).then((response) => {
                    this.isTableLoading = false;
                    if (response.status === 0) {
                        if (response.data) {
                            this.consumptionList = response.data.list;
                            this.totalVerifyNum = response.data.totalVerifyNum;
                            this.totalRevocationNum = response.data.totalRevocationNum;
                            this.totalCount = response.data.totalSize;
                        }
                        if (response.data.list.length === 0) {
                            this.noData = true;
                        }
                        else {
                            this.noData = false;
                        }
                    } else {
                        this.alert(response.message || '接口返回信息有误');
                    }
                }).catch((error) => {
                    this.isTableLoading = false;
                    this.consumptionList = [];
                    this.alert(error.message || error);
                });
            },
            getDeals () {
                api.getDeals({
                    bizAccountAccess: this.bizAccountAccess
                }).then((response) => {
                    this.isTableLoading = false;
                    if (response.status === 0) {
                        if (response.data) {
                            this.dealList = response.data;
                        }
                    } else {
                        this.alert(response.message || '接口返回信息有误');
                    }
                }).catch((error) => {
                    this.isTableLoading = false;
                    this.dealList = [];
                    this.alert(error);
                });
            },
            currentChangeFunc (data) {
                this.current = data.current;
                this.searchInfo = false;
                this.getConsumptionList();
            },
            before (index, day) {
                let today = new Date();
                let nowVal = today.valueOf();
                let TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
                this.useTimeStart = this.getDateTime(TimeStart);
                this.useTimeEnd = this.getDateTime(today);
                this.selectedIndex = index;
            },
            getDateTime (date) {
                let result = '';
                if (date) {
                    result += date.getFullYear() + '-';
                    let month = date.getMonth() + 1;
                    result += month < 10 ? '0' + month : month;
                    result += '-';
                    let dateInMonth = date.getDate();
                    result += dateInMonth < 10 ? '0' + dateInMonth : dateInMonth;
                }
                return result;
            },
            check () {
                if (!this.useTimeStart || !this.useTimeEnd) {
                    this.alert('必须选择起止时间!');
                    return false;
                }
                if (this.useTimeStart > this.useTimeEnd) {
                    this.alert('开始时间必须小于结束时间!');
                    return false;
                }
                return true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-fluid {
        margin-top: 20px;
        .time-filter {
            display: inline-block;
            padding: 3px 10px;
            margin: 0 5px;
            border: 2px solid #eee;
            color: #2bb8aa;
            cursor: pointer;
        }

        .active {
            background-color: #2bb8aa;
            color: white;
        }

        .col-item {
            position: relative;
            min-height: 1px;
            padding-left: 16px;
            padding-right: 15px;
            display: inline-block;
        }

        .common-tip-blk {
            border: 1px solid #eee;
            line-height: 40px;
            padding: 0 20px;
            margin-top: 10px;
            .F-glob {
                color: #2bb8aa;
                font-family: global-iconfont;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                text-decoration: none;
            }
            .F-glob-status-info:before {
                content: "\e90e";
            }
        }

        .table-wrapper {
            .pull-right {
                float: right!important;
                color: #2bb8aa;
                cursor: pointer;
            }
        }

        a[disabled] {
            cursor: not-allowed;
        }

        .nodata {
            width: 150px;
            margin: 0 auto;
        }
    }
</style>





// WEBPACK FOOTER //
// singleProgramConsumption.vue?b74b75c8